const initialState = {
  count: 0,
  results: [],
};

const deviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'DEVICE_GET_DONE':
      return { ...action.payload };
    default:
      return state;
  }
};

export default deviceReducer;
